// carpet-tile products (15 items)
export const productsCarpetTile = [
  {
    id: 5,
    slug: "diplomat-tile",
    name: "Diplomat Tile",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/diplomat-tile/PS_ISS_Diplomat.pdf",
    techSpecsPdf: "/Assets/pdf/diplomat-tile/PS_TechSpecs_Diplomat.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 5,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "tan", "brown"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/diplomat-tile/diplomat_united.jpg",
    heroImage: "/Assets/images/products/diplomat-tile/diplomat_united.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium (eco) Bitumen or TacFast™",
      thickness: "0.44 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue -down or TacFast w/tape install",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Made with 100% ASOTA® polypropylene fibers",
      "UV stable, stain resistant",
      "Durable and a highly resilient non-woven carpet"
    ],
    gallery: [
      "/Assets/images/products/diplomat-tile/uploaded/diplomat_hardware_store.jpg",
      "/Assets/images/products/diplomat-tile/uploaded/diplomat_jims_supervalu.jpg",
      "/Assets/images/products/diplomat-tile/uploaded/diplomat_food_lion_2153.jpg",
      "/Assets/images/products/diplomat-tile/uploaded/diplomat_food_lion_10.jpg",
      "/Assets/images/products/diplomat-tile/uploaded/diplomat_vestibule.jpg",
      "/Assets/images/products/diplomat-tile/diplomat_united.jpg",
      "/Assets/images/products/Diplomat/diplomat_hero-img.jpg",
      "/Assets/images/products/diplomat-tile/diplomat_grocery.jpeg",
      "/Assets/images/new-product-imgs/Diplomat/Diplomat_02.jpg",
      "/Assets/images/new-product-imgs/Diplomat/Diplomat_03.jpg",
      "/Assets/images/new-product-imgs/Diplomat/diplomat_04.jpg"
    ],
    swatches: [
      { name: "Carbon", image: "/Assets/images/products/Diplomat/Carbon.jpg" },
      { name: "Heath", image: "/Assets/images/products/Diplomat/Heath.jpg" },
      { name: "Mink", image: "/Assets/images/products/Diplomat/Mink.jpg" },
      { name: "Smoke", image: "/Assets/images/products/Diplomat/Smoke.jpg" },
      { name: "Tan", image: "/Assets/images/products/Diplomat/Tan.jpg" }
    ],
    fourUpSwatches: [
      { name: "Carbon", image: "/Assets/images/products/Diplomat/four-up/Carbon_Four-Tile.jpg" },
      { name: "Heath", image: "/Assets/images/products/Diplomat/four-up/Heath_Four-Tile.jpg" },
      { name: "Mink", image: "/Assets/images/products/Diplomat/four-up/Mink_Four-Tile.jpg" },
      { name: "Smoke", image: "/Assets/images/products/Diplomat/four-up/Smoke_Four-Tile.jpg" },
      { name: "Tan", image: "/Assets/images/products/Diplomat/four-up/Tan_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: "Diplomat Carpet Tiles help you protect your busiest spaces, without sacrificing durability or appearance. When your entryways and retail workplaces face constant foot and cart traffic, you need flooring that can handle the pressure day after day. That's why Diplomat Carpet Tiles are designed as a long-term solution for high-demand environments. Built tough for heavy traffic areas, they help you maintain a clean, professional look, even in your most heavily used spaces. Made from 100% ASOTA® polypropylene fibers, Diplomat Carpet Tiles deliver reliable performance where it matters most, resisting wear while staying easy to maintain.",
    features: [
      "Made with 100% ASOTA® polypropylene fibers",
      "UV stable, stain resistant",
      "Durable and a highly resilient non-woven carpet"
    ],
    specifications: {
      construction: "Nonwoven high/low dirt pocket pattern",
      fiberContent: "100% Solution-dyed UV stabilized ASOTA® polypropylene",
      faceWeight: "60 OZ. HIGH-LOW STRUCTURED LOOP CARPET TILE"
    }
  },
  {
    id: 6,
    slug: "dominator-tile",
    name: "Dominator Tile",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/dominator-tile/PS_ISS_DominatorLP.pdf",
    techSpecsPdf: "/Assets/pdf/dominator-tile/PS_TechSpecs_Dominator.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 6,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "tan", "brown"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/dominator-tile/dominator_kroger.jpg",
    heroImage: "/Assets/images/products/dominator-tile/dominator_kroger.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium (eco) Bitumen or TacFast™",
      thickness: "0.50 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue -down or TacFast w/tape install",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Our heaviest and most durable product in the line",
      "Inviting, resilient design made for long-term wear",
      "Available with Bitumen & TacFast backing"
    ],
    gallery: [
      "/Assets/images/products/dominator-tile/dominator_kroger.jpg",
      "/Assets/images/products/dominator-tile/dominator_weis_carts.jpg",
      "/Assets/images/products/dominator-tile/dominator_weis_entry.jpg",
      "/Assets/images/new-product-imgs/Dominator/dominator_02.jpg",
      "/Assets/images/new-product-imgs/Dominator/dominator_03.jpg",
      "/Assets/images/products/dominator-tile/dominator_gym5.jpg"
    ],
    swatches: [
      { name: "Anthracite", image: "/Assets/images/products/Dominator/Dominator_Anthracite.jpg" },
      { name: "Heath", image: "/Assets/images/products/Dominator/Dominator_Heath.jpg" },
      { name: "Indigo Blue", image: "/Assets/images/products/Dominator/Dominator_IndigoBlue.jpg" },
      { name: "Mid Grey", image: "/Assets/images/products/Dominator/Dominator_MidGrey.jpg" },
      { name: "Pebble", image: "/Assets/images/products/Dominator/Dominator_Pebble.jpg" },
      { name: "Walnut", image: "/Assets/images/products/Dominator/Dominator_Walnut.jpg" }
    ],
    fourUpSwatches: [
      { name: "Anthracite", image: "/Assets/images/products/Dominator/four-up/Anthracite_Four-Tile.jpg" },
      { name: "Heath", image: "/Assets/images/products/Dominator/four-up/Heath_Four-Tile.jpg" },
      { name: "Indigo Blue", image: "/Assets/images/products/Dominator/four-up/IndigoBlue_Four-Tile.jpg" },
      { name: "Mid Grey", image: "/Assets/images/products/Dominator/four-up/MidGrey_Four-Tile.jpg" },
      { name: "Pebble", image: "/Assets/images/products/Dominator/four-up/Pebble_Four-Tile.jpg" },
      { name: "Walnut", image: "/Assets/images/products/Dominator/four-up/Walnut_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: "Dominator Carpet Tiles help you protect high-traffic entryways and workplaces—without worrying about wear or failure. When your space faces constant foot traffic and rolling carts, you need flooring that's built to last in demanding retail environments. That's why Dominator Carpet Tiles are engineered as the toughest option in our lineup. Designed to perform in your busiest areas, they help you maintain a professional, inviting space while standing up to daily abuse. Made with 100% ASOTA® polypropylene fibers, this highly resilient nonwoven carpet is UV stable, stain resistant, and built for long-term performance in entryways and workplaces alike.",
    features: [
      "Our heaviest and most durable product in the line",
      "Inviting, resilient design made for long-term wear",
      "Available with Bitumen & TacFast backing"
    ],
    specifications: {
      faceWeight: "60 OZ. NONWOVEN CONTRACT CARPET TILE",
      construction: "Nonwoven Diagonal Pattern Fiber",
      fiberContent: "100% Solution-dyed UV stabilized ASOTA® polypropylene"
    }
  },
  {
    id: 7,
    slug: "hercules-mxp",
    name: "Hercules MXP",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/hercules-mxp/PS_ISS_HerculesMXP.pdf",
    techSpecsPdf: "/Assets/pdf/hercules-mxp/PS_TSS_HerculesMXP.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 1,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Educational Institutions", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["grey"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/Hercules-MXP/hercules_thumbnail.jpg",
    heroImage: "/Assets/images/products/Hercules-MXP/hercules_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "Blend of Polypropylene and Polyester",
      construction: "Non-woven",
      backing: "Premium (eco) Bitumen or TacFast™",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue -down or TacFast w/tape install",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Unparalleled premium style",
      "Natural look and feel",
      "Hard-wearing durability"
    ],
    gallery: [
      "/Assets/images/products/Hercules-MXP/hercules_hero-img.jpg",
      "/Assets/images/products/hercules-mxp/aldi_vestibule.jpg",
      "/Assets/images/products/hercules-mxp/hercules_grocery.jpg",
      "/Assets/images/products/hercules-mxp/target_katy_closeup.jpg"
    ],
    swatches: [
      { name: "Heather Grey", image: "/Assets/images/products/Hercules-MXP/HerculesMXP_HeatherGrey.jpg" }
    ],
    fourUpSwatches: [
      { name: "Heather", image: "/Assets/images/products/Hercules-MXP/four-up/Heather_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: "Hercules MXP Tiles help you create durable, modern spaces, without high maintenance or high costs. When you need a flooring solution that can handle heavy use while remaining easy to maintain and cost-effective, you need performance you can rely on. That's why Hercules MXP is designed for demanding, high-traffic environments. Its 4 by 2 ribbed corduroy construction delivers hard-wearing durability while maintaining a clean, modern aesthetic that elevates your interior spaces. With distinctive good looks and premium performance, Hercules MXP Tiles are built to withstand daily wear, helping you maintain a professional appearance without constant upkeep.",
    features: [
      "Unparalleled premium style",
      "Natural look and feel"
    ],
    specifications: {
      faceWeight: "54 OZ. FOUR-BY-TWO RIB CARPET TILE",
      fiberContent: "Blend of Polypropylene and Polyester",
      construction: "Non-woven"
    }
  },
  {
    id: 9,
    slug: "kensington-tile",
    name: "Kensington Tile",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/kensington-tile/PS_ISS_Kensington_CT.pdf",
    techSpecsPdf: "/Assets/pdf/kensington-tile/PS_TechSpecs_Kensington.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 5,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "blue", "brown", "charcoal", "red"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/kensington-tile/kensington_darkgrey.jpeg",
    heroImage: "/Assets/images/products/kensington-tile/kensington_darkgrey.jpeg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "PA6 Space Dyed Nylon",
      construction: "Tufted",
      backing: "Premium (ECO) Bitumen",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Designer striae pattern inspired by nature",
      "Premium style with commercial-grade durability",
      "Quarter turn installation for unique visual effects"
    ],
    gallery: [
      "/Assets/images/products/kensington-tile/kensington_darkgrey.jpeg",
      "/Assets/images/products/Kensington-CTG/kensington_hero-img.jpg",
      "/Assets/images/products/kensington-tile/kensington_5O6B0039.jpg",
      "/Assets/images/new-product-imgs/Kensington-CTG/kensington_02.jpg",
      "/Assets/images/new-product-imgs/Kensington-CTG/kensington_03.jpg",
      "/Assets/images/products/kensington-tile/kensington_install.jpg"
    ],
    swatches: [
      { name: "Charcoal", image: "/Assets/images/products/Kensington-CTG/kensington_-(1).jpg" },
      { name: "Dark Grey", image: "/Assets/images/products/Kensington-CTG/kensington_-(2).jpg" },
      { name: "Navy", image: "/Assets/images/products/Kensington-CTG/kensington_-(3).jpg" },
      { name: "Taupe", image: "/Assets/images/products/Kensington-CTG/kensington_-(4).jpg" },
      { name: "Red", image: "/Assets/images/products/Kensington-CTG/kensington_-(5).jpg" }
    ],
    fourUpSwatches: [
      { name: "Charcoal", image: "/Assets/images/products/Kensington/four-up/Charcoal_Four-Tile.jpg" },
      { name: "Dark Grey", image: "/Assets/images/products/Kensington/four-up/DarkGrey_Four-Tile.jpg" },
      { name: "Navy", image: "/Assets/images/products/Kensington/four-up/Navy_Four-Tile.jpg" },
      { name: "Red", image: "/Assets/images/products/Kensington/four-up/Red_Four-Tile.jpg" },
      { name: "Taupe", image: "/Assets/images/products/Kensington/four-up/Taupe_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: "Kensington Premium Carpet Tiles help you create comfortable, stylish commercial spaces that perform under pressure. When you want a space that looks refined yet stands up to heavy traffic, you need flooring that balances design and durability. That's why Kensington has become a designer favorite for commercial environments. Inspired by striae patterns found in nature, its subtle, warm design adds energy and movement, especially when tiles are quarter turned, while remaining easy on the eyes and tough enough for demanding traffic levels. Built for long-term performance, Kensington delivers premium style without compromising strength or comfort.",
    features: [
      "Available in carpet tile, sheet goods, & custom matting"
    ],
    specifications: {
      faceWeight: "30 OZ. DESIGNER STRIAE NYLON CARPET TILE",
      fiberContent: "100% PA6 Space Dyed Nylon"
    }
  },
  {
    id: 11,
    slug: "portico-nop-carpet-tile",
    name: "Portico Nop",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/portico-nop-carpet-tile/PS_ISS_PorticoNop.pdf",
    techSpecsPdf: "/Assets/pdf/portico-nop-carpet-tile/PS_TechSpecs_PorticoNop.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 21,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["neutral", "blue", "earth-tones", "green", "red", "charcoal", "grey", "tan", "brown", "multi-color"],
      patterns: ["berber", "modern"],
      budgetLevels: ["premium"],
    image: "/Assets/images/products/portico-nop-ctg/portico_college_entry.jpg",
    heroImage: "/Assets/images/products/portico-nop-ctg/portico_college_entry.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium (eco) Bitumen",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Dependable entryways in wet and high-traffic areas",
      "Wide range of colors for design flexibility",
      "All-weather performance and timeless design"
    ],
    gallery: [
      "/Assets/images/products/portico-nop-CTG/PN_CTG_hero-img.jpg",
      "/Assets/images/new-product-imgs/Portico-Nop-CTG/Portico-Tile_02.jpg",
      "/Assets/images/products/portico-nop-ctg/portico_college_entry.jpg",
      "/Assets/images/new-product-imgs/Portico-Nop-CTG/portico-tile_04.jpg",
      "/Assets/images/products/portico-nop-ctg/portico_tile_03.jpg"
    ],
    swatches: [
      { name: "Autumn", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Autumn.jpg" },
      { name: "Azure", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Azure.jpg" },
      { name: "Black Shadow", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_BlackShadow.jpg" },
      { name: "Cardinal Red", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_CardinalRed.jpg" },
      { name: "Charcoal", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Charcoal.jpg" },
      { name: "Chocolate", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Chocolate.jpg" },
      { name: "Coir", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Coir.jpg" },
      { name: "Garnet", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Garnet.jpg" },
      { name: "Hunter Green", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_HunterGreen.jpg" },
      { name: "Loden", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Loden.jpg" },
      { name: "Midnight Blue", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_MidnightBlue.jpg" },
      { name: "Natural Beige", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_NaturalBeige.jpg" },
      { name: "Prism", image: "/Assets/images/products/portico-nop-CTG/Prism.jpg" },
      { name: "Rosewood", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Rosewood.jpg" },
      { name: "Steel Blue", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_SteelBlue.jpg" },
      { name: "Sterling", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Sterling.jpg" },
      { name: "Taupe", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Taupe.jpg" },
      { name: "Teak", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Teak.jpg" },
      { name: "Verde Green", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_VerdeGreen.jpg" },
      { name: "Walnut", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Walnut.jpg" },
      { name: "Zinc", image: "/Assets/images/products/portico-nop-CTG/CSN_Tile_Zinc.jpg" }
    ],
    fourUpSwatches: [
      { name: "Autumn", image: "/Assets/images/products/portico-nop-CTG/four-up/Autumn_Four-Tile.jpg" },
      { name: "Azure", image: "/Assets/images/products/portico-nop-CTG/four-up/Azure_Four-Tile.jpg" },
      { name: "Black Shadow", image: "/Assets/images/products/portico-nop-CTG/four-up/BlackShadow_Four-Tile.jpg" },
      { name: "Cardinal Red", image: "/Assets/images/products/portico-nop-CTG/four-up/CardinalRed_Four-Tile.jpg" },
      { name: "Charcoal", image: "/Assets/images/products/portico-nop-CTG/four-up/Charcoal_Four-Tile.jpg" },
      { name: "Chocolate", image: "/Assets/images/products/portico-nop-CTG/four-up/Chocolate_Four-Tile.jpg" },
      { name: "Coir", image: "/Assets/images/products/portico-nop-CTG/four-up/Coir_Four-Tile.jpg" },
      { name: "Garnet", image: "/Assets/images/products/portico-nop-CTG/four-up/Garnet_Four-Tile.jpg" },
      { name: "Hunter Green", image: "/Assets/images/products/portico-nop-CTG/four-up/HunterGreen_Four-Tile.jpg" },
      { name: "Loden", image: "/Assets/images/products/portico-nop-CTG/four-up/Loden_Four-Tile.jpg" },
      { name: "Midnight Blue", image: "/Assets/images/products/portico-nop-CTG/four-up/MidnightBlue_Four-Tile.jpg" },
      { name: "Natural Beige", image: "/Assets/images/products/portico-nop-CTG/four-up/NaturalBeige_Four-Tile.jpg" },
      { name: "Prism", image: "/Assets/images/products/portico-nop-CTG/four-up/Prism_Four-Tile.jpg" },
      { name: "Rosewood", image: "/Assets/images/products/portico-nop-CTG/four-up/Rosewood_Four-Tile.jpg" },
      { name: "Steel Blue", image: "/Assets/images/products/portico-nop-CTG/four-up/SteelBlue_Four-Tile.jpg" },
      { name: "Sterling", image: "/Assets/images/products/portico-nop-CTG/four-up/Sterling_Four-Tile.jpg" },
      { name: "Taupe", image: "/Assets/images/products/portico-nop-CTG/four-up/Taupe_Four-Tile.jpg" },
      { name: "Teak", image: "/Assets/images/products/portico-nop-CTG/four-up/Teak_Four-Tile.jpg" },
      { name: "Verde Green", image: "/Assets/images/products/portico-nop-CTG/four-up/VerdeGreen_Four-Tile.jpg" },
      { name: "Walnut", image: "/Assets/images/products/portico-nop-CTG/four-up/Walnut_Four-Tile.jpg" },
      { name: "Zinc", image: "/Assets/images/products/portico-nop-CTG/four-up/Zinc_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: "Portico Nop Tile helps you elevate any space with dependable performance and standout style. When you need flooring that works across multiple applications, without compromising on looks or durability, you need a solution that's as flexible as your space. That's why Portico Nop Tile, our most popular logo mat material, is now available in both roll goods and tiles. Designed with warm neutrals, fashionable brights, and classic standard colors, it gives you the freedom to create cohesive, professional environments in virtually any setting. Built for all-weather performance, Portico Nop Tile combines timeless design with reliable functionality, making it our highest-quality option for spaces that demand both form and function.",
    features: [
      "Dependable entryways in wet and high-traffic areas",
      "Wide range of colors"
    ],
    specifications: {
      faceWeight: "54 OZ ALL-WEATHER BERBER CARPET",
      construction: "Non-woven/needlepunched",
      pattern: "Hobnail (berber) pattern",
      fiberContent: "100% Solution-dyed UV stabilized ASOTA® polypropylene"
    }
  },
  {
    id: 21,
    slug: "dominator-lp",
    name: "Dominator LP Tile",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/dominator-lp/PS_ISS_DominatorLP.pdf",
    techSpecsPdf: "/Assets/pdf/dominator-lp/PS_TechSpecs_DominatorLP.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 7,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "tan", "brown", "green", "red"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/dominator-lp/domlp_olive_gym.jpg",
    heroImage: "/Assets/images/products/dominator-lp/domlp_olive_gym.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium (ECO) Bitumen",
      thickness: "0.37 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "adhesive laid install",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
    keyFeatures: [
      "Extremely durable carpet tile",
      "A lower-profile solution",
      "Full performance of Dominator in a lighter & thinner style"
    ],
    gallery: [
      "/Assets/images/products/dominator-lp/DominatorLP_hero.jpg",
      "/Assets/images/products/dominator-lp/DominatorLP_-(2).jpg",
      "/Assets/images/products/dominator-lp/DominatorLP_-(3).jpg",
      "/Assets/images/products/dominator-lp/DominatorLP_-(5).jpg",
      "/Assets/images/products/dominator-lp/domlp_verizon_grey.jpg"
    ],
    swatches: [
      { name: "Anthracite", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Anthracite.jpg" },
      { name: "Autumn Green", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Autumn-Green.jpg" },
      { name: "Black Shadow", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Black-Shadow.jpg" },
      { name: "Cranberry", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Cranberry.jpg" },
      { name: "Mid Grey", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Mid-Grey.jpg" },
      { name: "Olive", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Olive.jpg" },
      { name: "Pebble", image: "/Assets/images/products/dominator-lp/Swatches/Single-Tile-Swatch/Pebble.jpg" }
    ],
    fourUpSwatches: [
      { name: "Anthracite", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/Anthracite_Four-Tile.jpg" },
      { name: "Autumn Green", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/AutumnGreen_Four-Tile.jpg" },
      { name: "Black Shadow", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/BlackShadow_Four-Tile.jpg" },
      { name: "Cranberry", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/Cranberry_Four-Tile.jpg" },
      { name: "Mid Grey", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/MidGrey_Four-Tile.jpg" },
      { name: "Olive", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/Olive_Four-Tile.jpg" },
      { name: "Pebble", image: "/Assets/images/products/dominator-lp/Swatches/Four-Tile-Setups/Pebble_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you need a carpet tile that can handle heavy traffic without adding unnecessary weight to your project, you need a solution that balances durability with flexibility. The problem is that many high-performance carpet tiles are bulky, difficult to handle, or limit your design options.",
      "Dominator LP delivers the proven durability of Dominator in a lighter-weight construction that's easier to work with. Designed with a darker base that subtly reveals the tile's ribbed color accents, it helps you maintain a clean, professional look while standing up to demanding environments."
    ],
    features: [
      "39 oz. Diagonal-patterned needle-punched carpet tile",
      "Lighter and thinner tile",
      "Premium (ECO) Bitumen backing"
    ],
    specifications: {
      weight: "39 oz. Diagonal-patterned needle-punched carpet tile",
      backing: "Premium (ECO) Bitumen backing",
      profile: "Lighter and thinner tile"
    }
  },
  {
    id: 22,
    slug: "freestahyl-tile",
    name: "Freestahyl Tile",
    variant: "Carpet Tile",
    type: "Carpet Tile",
    category: "Carpet Tile",

    categoryId: "carpet-tile",    productSheetPdf: "/Assets/pdf/freestahyl-tile/PS_ISS_Freestahyl.pdf",
    techSpecsPdf: "/Assets/pdf/freestahyl-tile/PS_TSS_Freestahyl.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 7,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "green", "blue"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/freestahyl/Freestahyl_thumbnail.jpg",
    heroImage: "/Assets/images/products/freestahyl/Freestahyl_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus" }
    ],
    comparisonSpecs: {
      material: "Encore® SD Ultima®",
      construction: "Patterned Scroll",
      backing: "Nexus® Modular",
      thickness: "0.217 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zone 3",
      bestUseCase: "cooridors, hallways, office spaces"
    },
    keyFeatures: [
      "Approximate 24\" x 24\" carpet tile",
      "Construction Patterned Scroll",
      "Encore SD Ultima fiber with recycled content"
    ],
    gallery: [
      "/Assets/images/products/freestahyl/Freestahyl_hero.jpg",
      "/Assets/images/products/freestahyl/Freestahyl_(1).jpg"
    ],
    swatches: [
      { name: "Adobe", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Adobe.jpg" },
      { name: "Brice", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Brice.jpg" },
      { name: "Blackstone", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Blackstone.jpg" },
      { name: "Moleskin", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Moleskin.jpg" },
      { name: "Riverstone", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Riverstone.jpg" },
      { name: "Sloe", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Sloe.jpg" },
      { name: "Wren", image: "/Assets/images/products/freestahyl/Swatches/Single-Tile-Swatch/Wren.jpg" }
    ],
    fourUpSwatches: [
      { name: "Adobe", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Adobe_Four-Tile.jpg" },
      { name: "Brice", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Bice_Four-Tile.jpg" },
      { name: "Blackstone", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Blackstone_Four-Tile.jpg" },
      { name: "Moleskin", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Moleskin_Four-Tile.jpg" },
      { name: "Riverstone", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Riverstone_Four-Tile.jpg" },
      { name: "Sloe", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Sloe_Four-Tile.jpg" },
      { name: "Wren", image: "/Assets/images/products/freestahyl/Swatches/Four-Tile-Setups/Wren_Four-Tile.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you want to create a modern, visually engaging space, you need flooring that gives you both creative freedom and a cohesive design foundation. The problem is that many patterned tiles feel limiting—either too bold to coordinate easily or too subtle to make an impact.",
      "This modern-spirited conceptual motif flows seamlessly across 24\" x 24\" tiles in seven beautifully saturated neutral tones. The versatile palette allows you to design with confidence, giving you the flexibility to create dynamic layouts or subtle, sophisticated environments that reflect your vision."
    ],
    features: [
      "SCAS / NSF 140 Gold Certified",
      "Solution Dyed Fiber Type Encore SD Ultima",
      "Patterned Scroll construction"
    ],
    specifications: {
      size: "24\" x 24\" carpet tile",
      certification: "SCAS / NSF 140 Gold Certified",
      fiber: "Solution Dyed Fiber Type Encore SD Ultima"
    }
  },
  {
      id: 38,
      slug: "atlas-plus-ctg",
      name: "Atlas Plus",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/atlas-plus-ctg/PS_ISS_AtlasPlus.pdf",
    techSpecsPdf: "/Assets/pdf/atlas-plus-ctg/PS_TechSpecs_AtlasPlus.pdf",
      saleSheetPdf: "/Assets/pdf/atlas-plus-ctg/PS_ISS_AtlasPlus.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
      colorCount: 1,
      sizeFormat: "Tiles",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["charcoal"],
      patterns: ["ribbed", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/atlas-plus-ctg/atlas_plus_v3.jpg",
      heroImage: "/Assets/images/products/atlas-plus-ctg/atlas_plus_v3.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
      comparisonSpecs: {
        material: "ASOTA® polypropylene fibers",
        construction: "Non-woven",
        backing: "Premium (ECO) Bitumen",
        thickness: "0.47 inch",
        trafficRating: "High",
        slipResistance: "Yes",
        installationType: "Glue -down",
        recommendedZone: "Zones 1, 2, 3",
        bestUseCase: "Vestibules, entryways, hallways"
      },
    keyFeatures: ["High-performance needle-punched construction", "Made to perform using solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Highly versatile and available in premium (eco) bitumen or TacFast\u2122 backing"],
      gallery: ["/Assets/images/products/atlas-plus-ctg/atlas_plus_v3.jpg", "/Assets/images/products/atlas-plus-ctg/atlas-plus-ctg_gallery_1.jpg", "/Assets/images/products/atlas-plus-ctg/atlas_grocery_v2.jpg", "/Assets/images/products/atlas-plus-ctg/atlas_library_charcoal.jpg", "/Assets/images/products/atlas-plus-ctg/atlas_plus_doorway_install.jpg"],
      swatches: [
        {name: "Charcoal", image: "/Assets/images/products/atlas-plus-ctg/swatches/AtlasPlus_Charcoal.jpg"}
      ],
      isPlaceholder: false,
      description: "For designers and facility teams working in busy commercial interiors, flooring needs to perform without sacrificing visual structure. Atlas Plus brings a refined linear texture in a modular tile format, making it easier to design organized, modern spaces while controlling dirt and wear in high-traffic areas. Built with durable needle-punched construction and solution-dyed, UV-stabilized polypropylene fibers, Atlas Plus is engineered for long-term performance and flexible installation with eco-bitumen or TacFast™ backing options.",
      features: ["High-performance needle-punched construction", "Made to perform using solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Highly versatile and available in premium (eco) bitumen or TacFast\u2122 backing"],
      specifications: {},
      fourUpSwatches: [
        {name: "Atlasplus Charcoal", image: "/Assets/images/products/atlas-plus-ctg/four-up/AtlasPlus_4Tile_Charcoal.jpg"}
      ]
    },
  {
      id: 41,
      slug: "championlp-ctg",
      name: "Champion LP",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",
    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/championlp-ctg/PS_ISS_Champion_LP.pdf",
    techSpecsPdf: "/Assets/pdf/tech-specs/PS_TSS_ChampionLP.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
      colorCount: 6,
      sizeFormat: "Tiles",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "brown", "red", "charcoal"],
      patterns: ["berber", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/championlp-ctg/championlp_gym3.jpg",
      heroImage: "/Assets/images/products/championlp-ctg/championlp_sisal_dentist.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium (ECO) Bitumen",
      thickness: "0.34 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Vestibules, entryways, hallways"
    },
      keyFeatures: ["Lower Profile than Champion XP", "Can withstand dirt and water", "Dense Berber tile resilient to crushing"],
      gallery: ["/Assets/images/products/championlp-ctg/championlp_gym3.jpg", "/Assets/images/products/championlp-ctg/gym_championlp.jpg", "/Assets/images/products/championlp-ctg/championlp_office_grey.jpg", "/Assets/images/products/championlp-ctg/championlp_marble_officehall.jpg", "/Assets/images/products/championlp-ctg/championlp_sisal_dentist.jpg"],
      swatches: [
        {name: "Marble", image: "/Assets/images/products/channel-rib-ctg/swatches/Marble-1593.jpg"},
        {name: "Khaki", image: "/Assets/images/products/channel-rib-ctg/swatches/Khaki-1006.jpg"},
        {name: "Beige", image: "/Assets/images/products/channel-rib-ctg/swatches/Beige1153.jpg"},
        {name: "Solid Crimson", image: "/Assets/images/products/channel-rib-ctg/swatches/Solid-Crimson-3031.jpg"},
        {name: "Smokey Grey", image: "/Assets/images/products/channel-rib-ctg/swatches/Smokey-Grey-1531.jpg"},
        {name: "Chocolate", image: "/Assets/images/products/channel-rib-ctg/swatches/Chocolate-1097.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities need entrance matting that controls dirt and moisture without stretching the budget. Champion LP delivers dependable performance with a classic ribbed design that helps channel water away while making dirt and debris easy to sweep or vacuum. Made with 100% solution-dyed, UV-stabilized polypropylene and a durable vinyl backing, it performs reliably in both indoor and outdoor applications. Ideal for entryways and ramps, Champion LP provides a practical, cost-effective matting solution for busy commercial spaces.",
      features: ["Lower Profile than Champion XP", "Can withstand dirt and water", "Dense Berber tile resilient to crushing"],
      specifications: {},
      fourUpSwatches: [
        {name: "Marble", image: "/Assets/images/products/channel-rib-ctg/four-up/Marble_4Tile.jpg"},
        {name: "Smokey", image: "/Assets/images/products/channel-rib-ctg/four-up/Smokey_4Tile.jpg"},
        {name: "Crimson", image: "/Assets/images/products/channel-rib-ctg/four-up/Crimson_4Tile.jpg"},
        {name: "Khaki", image: "/Assets/images/products/channel-rib-ctg/four-up/Khaki_4Tile.jpg"},
        {name: "Beige", image: "/Assets/images/products/channel-rib-ctg/four-up/Beige_4Tile.jpg"},
        {name: "Chocolate", image: "/Assets/images/products/channel-rib-ctg/four-up/Chocolate_4Tile.jpg"}
      ]
    },
  {
      id: 47,
      slug: "cross-guard-tile-ctg",
      name: "Cross Guard Tile",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/cross-guard-tile-ctg/PS_ISS_CrossGuard.pdf",
    techSpecsPdf: "/Assets/pdf/cross-guard-tile-ctg/PS_TSS_Crossguard.pdf",
      saleSheetPdf: "/Assets/pdf/cross-guard-tile-ctg/PS_ISS_CrossGuard.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 3,
      sizeFormat: "Tiles",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "green"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/cross-guard-tile-ctg/cross-guard-tile-ctg_thumbnail.jpg",
      heroImage: "/Assets/images/products/cross-guard-tile-ctg/cross-guard-tile-ctg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "TeraPlex® SD PET",
      construction: "Patterned Scroll",
      backing: "Nexus® Modular",
      thickness: "0.245 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zone 3",
      bestUseCase: "cooridors, hallways, office spaces"
    },
      keyFeatures: ["Standard size 24\u201d x 24\u201d approx. (60.96cm x 60.96cm)", "1/12 (4.72 rows/cm) Gauge"],
      gallery: ["/Assets/images/products/cross-guard-tile-ctg/crossguard_grey_office.jpg", "/Assets/images/products/cross-guard-tile-ctg/crossguard_slate_lobby.jpg", "/Assets/images/products/cross-guard-tile-ctg/cross-guard-tile-ctg_gallery_1.jpg", "/Assets/images/products/cross-guard-tile-ctg/cross-guard-tile-ctg_gallery_2.jpg"],
      swatches: [
        {name: "Steel", image: "/Assets/images/products/cross-guard-tile-ctg/swatches/CrossGuard_Steel.jpg"},
        {name: "Dapple Grey", image: "/Assets/images/products/cross-guard-tile-ctg/swatches/CrossGuard_DappleGrey.jpg"},
        {name: "Slate", image: "/Assets/images/products/cross-guard-tile-ctg/swatches/CrossGuard_Slate.jpg"}
      ],
      isPlaceholder: false,
      description: "Commercial spaces need flooring that manages heavy traffic while contributing to a cohesive design. Cross Guard offers a solution inspired by the intersecting patterns of urban pathways, blending layered lines with a textured base of neutral earth tones. The result is a carpet tile that brings subtle movement and visual structure to a space while supporting the durability and performance required in busy commercial environments.",
      features: ["Standard size 24\u201d x 24\u201d approx. (60.96cm x 60.96cm)", "1/12 (4.72 rows/cm) Gauge"],
      specifications: {},
      fourUpSwatches: [
        {name: "Crossguard Steel", image: "/Assets/images/products/cross-guard-tile-ctg/four-up/Crossguard_4Tile_Steel.jpg"},
        {name: "Crossguard Slate", image: "/Assets/images/products/cross-guard-tile-ctg/four-up/Crossguard_4Tile_Slate.jpg"},
        {name: "Crossguard Dapplegrey", image: "/Assets/images/products/cross-guard-tile-ctg/four-up/Crossguard_4Tile_DappleGrey.jpg"}
      ]
    },
  {
      id: 58,
      slug: "premier-nop-ctg",
      name: "Premier Nop",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/premier-nop-ctg/PS_ISS_PremierNop.pdf",
    techSpecsPdf: "/Assets/pdf/premier-nop-ctg/PS_TechSpecs_PremierNop.pdf",
      saleSheetPdf: "/Assets/pdf/premier-nop-ctg/PS_ISS_PremierNop.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
      colorCount: 11,
      sizeFormat: "Tiles",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["neutral", "grey", "blue", "earth-tones", "red", "green"],
      patterns: ["berber", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/premier-nop-ctg/hotel_bordeaux.jpg",
      heroImage: "/Assets/images/products/premier-nop-ctg/hotel_bordeaux.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
      comparisonSpecs: {
        material: "ASOTA® polypropylene fibers",
        construction: "Non-woven",
        backing: "Premium (ECO) Bitumen",
        thickness: "0.47 inch",
        trafficRating: "Medium",
        slipResistance: "Yes",
        installationType: "Glue -down",
        recommendedZone: "Zones 1, 2, 3",
        bestUseCase: "Vestibules, entryways, hallways"
      },
    keyFeatures: ["A particularly effective and stylish entrance flooring", "Perfectly at home in high-traffic environments", "Provides extra-high dirt absorption"],
      gallery: ["/Assets/images/products/premier-nop-ctg/hotel_bordeaux.jpg", "/Assets/images/products/premier-nop-ctg/premiernop_midnightblue_mensstore.jpg", "/Assets/images/products/premier-nop-ctg/premier-nop-ctg_gallery_2.jpg", "/Assets/images/products/premier-nop-ctg/premiernop_grocery_charcoal.jpg", "/Assets/images/products/premier-nop-ctg/premiernop_aspen_checkout.jpg"],
      swatches: [
        {name: "Beige", image: "/Assets/images/products/premier-nop-ctg/swatches/Beige.jpg"},
        {name: "Aspen", image: "/Assets/images/products/premier-nop-ctg/swatches/Aspen.jpg"},
        {name: "Anthracite", image: "/Assets/images/products/premier-nop-ctg/swatches/Anthracite.jpg"},
        {name: "Sisal", image: "/Assets/images/products/premier-nop-ctg/swatches/Sisal.jpg"},
        {name: "Midnight Blue", image: "/Assets/images/products/premier-nop-ctg/swatches/Midnight-Blue.jpg"},
        {name: "Chocolate", image: "/Assets/images/products/premier-nop-ctg/swatches/Chocolate.jpg"},
        {name: "Sterling", image: "/Assets/images/products/premier-nop-ctg/swatches/Sterling.jpg"},
        {name: "Bordeaux", image: "/Assets/images/products/premier-nop-ctg/swatches/Bordeaux.jpg"},
        {name: "Azure", image: "/Assets/images/products/premier-nop-ctg/swatches/Azure.jpg"},
        {name: "Harvest", image: "/Assets/images/products/premier-nop-ctg/swatches/Harvest.jpg"},
        {name: "Black Shadow", image: "/Assets/images/products/premier-nop-ctg/swatches/Black-Shadow.jpg"}
      ],
      isPlaceholder: false,
      description: "Daily foot traffic brings in grit, moisture, and debris that can quickly degrade surrounding floors. Premier Nop helps manage that challenge with a durable fiber-bond Berber surface designed to capture contaminants before they spread through the building. The high- heel friendly construction performs reliably in busy commercial entrances, while its strong dirt-trapping capability helps reduce maintenance and protect interior flooring. Premier Nop delivers dependable entrance protection in a practical, cost-effective mating solution.",
      features: ["A particularly effective and stylish entrance flooring", "Perfectly at home in high-traffic environments", "Provides extra-high dirt absorption"],
      specifications: {},
      fourUpSwatches: [
        {name: "Bordeaux", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Boureaux.jpg"},
        {name: "Chocolate", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Chocolate.jpg"},
        {name: "Brown Sugar", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_BrownSugar.jpg"},
        {name: "Anthracite", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Anthracite.jpg"},
        {name: "Sterling", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Sterling.jpg"},
        {name: "Harvest", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Harvest.jpg"},
        {name: "Midnight Sky", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Midnight-Sky.jpg"},
        {name: "Sisal", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Sisal.jpg"},
        {name: "Black Shadow", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Black-Shadow.jpg"},
        {name: "Aspen", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Aspen.jpg"},
        {name: "Azure", image: "/Assets/images/products/premier-nop-ctg/four-up/PremierNop_Four-Tile_Azure.jpg"}
      ]
    },
  {
      id: 60,
      slug: "rover-tiles-ctg",
      name: "Rover Tiles",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/rover-tiles-ctg/PS_ISS_Rover.pdf",
    techSpecsPdf: "/Assets/pdf/rover-tiles-ctg/PS_TSS_Rover.pdf",
      saleSheetPdf: "/Assets/pdf/rover-tiles-ctg/PS_ISS_Rover.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
      colorCount: 5,
      sizeFormat: "Tiles",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["tan", "blue", "grey", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/rover-tiles-ctg/rover_lobby_thumbnail.jpg",
      heroImage: "/Assets/images/products/rover-tiles-ctg/rover-tiles-ctg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "TeraPlex® SD PET",
      construction: "Patterned Scroll",
      backing: "Nexus® Modular",
      thickness: "0.213 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue -down",
      recommendedZone: "Zone 3",
      bestUseCase: "cooridors, hallways, office spaces"
    },
      keyFeatures: ["Five quick ship colorways with subtle neutrals and strategically placed stripes", "Mimics the effect of shadows and light on linear design", "Interplay of tone-on-tone lines that fade and meld into each other"],
      gallery: ["/Assets/images/products/rover-tiles-ctg/rover-tiles-ctg_gallery_1.jpg", "/Assets/images/products/rover-tiles-ctg/rover_lobby_thumbnail.jpg", "/Assets/images/products/rover-tiles-ctg/rover-tiles-ctg_gallery_3.jpg"],
      swatches: [
        {name: "Solar Linen", image: "/Assets/images/products/rover-tiles-ctg/swatches/Solar-Linen.jpg"},
        {name: "Jet Lag", image: "/Assets/images/products/rover-tiles-ctg/swatches/Jet-Lag.jpg"},
        {name: "Interlapse Grey", image: "/Assets/images/products/rover-tiles-ctg/swatches/Interlapse-Grey.jpg"},
        {name: "Standard Tan", image: "/Assets/images/products/rover-tiles-ctg/swatches/Standard-Tan.jpg"},
        {name: "Cosmic Blue", image: "/Assets/images/products/rover-tiles-ctg/swatches/Cosmic-Blue.jpg"}
      ],
      isPlaceholder: false,
      description: "Commercial interiors benefit from flooring that adds visual interest without overwhelming the space. Rover Carpet Tiles feature a linear design that plays with light and shadow, creating tone-on-tone movement across the floor. The subtle stripe pattern blends naturally into neutral palettes, giving designers flexibility to create dynamic layouts without sacrificing balance. With five quick-ship colorways and a modular tile format, Rover makes it easy to design spaces that feel both modern and effortlessly coordinated.",
      features: ["Five quick ship colorways with subtle neutrals and strategically placed stripes", "Mimics the effect of shadows and light on linear design", "Interplay of tone-on-tone lines that fade and meld into each other"],
      specifications: {},
      fourUpSwatches: [
        {name: "Rover Solarlinen", image: "/Assets/images/products/rover-tiles-ctg/four-up/Rover_4Tile_SolarLinen.jpg"},
        {name: "Rover Standardtan", image: "/Assets/images/products/rover-tiles-ctg/four-up/Rover_4Tile_StandardTan.jpg"},
        {name: "Rover Interlapsegrey", image: "/Assets/images/products/rover-tiles-ctg/four-up/Rover_4Tile_InterlapseGrey.jpg"},
        {name: "Rover Jetlag", image: "/Assets/images/products/rover-tiles-ctg/four-up/Rover_4Tile_JetLag.jpg"},
        {name: "Rover Cosmicblue", image: "/Assets/images/products/rover-tiles-ctg/four-up/Rover_4Tile_CosmicBlue.jpg"}
      ]
    },
  {
      id: 62,
      slug: "safeguard-giant-tiles-ctg",
      name: "Safeguard Giant Tiles",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/safeguard-giant-tiles-ctg/PS_ISS_SafeguardGiantTile.pdf",
    techSpecsPdf: "/Assets/pdf/safeguard-giant-tiles-ctg/PS_TechSpecs_SafeguardGiant.pdf",
      saleSheetPdf: "/Assets/pdf/safeguard-giant-tiles-ctg/PS_ISS_SafeguardGiantTile.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 1,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Educational Institutions", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["grey"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/safeguard-giant-tiles-ctg/safeguard_gym_02.jpg",
      heroImage: "/Assets/images/products/safeguard-giant-tiles-ctg/safeguard_gym_02.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
    comparisonSpecs: {
      material: "Polyester Non-woven Flat",
      construction: "Non-woven",
      backing: "Sure Back Coating",
      thickness: "0.228 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "rolls loose lay",
      recommendedZone: "Zone 3",
      bestUseCase: "vestibules, store aisles, gymnasiums"
    },
      keyFeatures: ["Temporary flooring", "No tools, tape or glue needed for installation", "Quick and easy setup and breakdown"],
      gallery: ["/Assets/images/products/safeguard-giant-tiles-ctg/safeguard_gym_02.jpg"],
      swatches: [
        {name: "Heather Grey", image: "/Assets/images/products/safeguard-giant-tiles-ctg/swatches/Heather-Grey.jpg"}
      ],
      isPlaceholder: false,
      description: "When facilities host concerts, graduations, or special events, protecting athletic flooring becomes a priority. Safeguard Giant Tiles provide a simple way to transform gymnasiums into multi-purpose spaces while shielding the floor from damage. These industrial-strength, reusable tiles are installed quickly without tools, tape, or adhesives, allowing crews to set up and break down event flooring with minimal effort. Lightweight, slip- resistant, and flexible, Safeguard Giant Tiles deliver dependable floor protection while maintaining a clean, professional appearance for any event.",
      features: ["Temporary flooring", "No tools, tape or glue needed for installation", "Quick and easy setup and breakdown"],
      specifications: {}
    },
  {
      id: 63,
      slug: "senator-softstep-plus-ctg",
      name: "Senator SoftStep™ Plus",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/senator-softstep-plus-ctg/PS_ISS_SenatorSoftStepPlus.pdf",
    techSpecsPdf: "/Assets/pdf/senator-softstep-plus-ctg/PS_TSS_SenatorSoftStepPlus.pdf",
      saleSheetPdf: "/Assets/pdf/senator-softstep-plus-ctg/PS_ISS_SenatorSoftStepPlus.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 2,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["charcoal", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/senator-softstep-plus-ctg/senator-softstep-plus-ctg_thumbnail.jpg",
      heroImage: "/Assets/images/products/senator-softstep-plus-ctg/senator-softstep-plus-ctg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
      comparisonSpecs: {
        material: "Polyester Non-woven Dilour with coating",
        construction: "Non-woven",
        backing: "Closed-Cell Expanded PVC",
        thickness: "0.62 inch",
        trafficRating: "Medium",
        slipResistance: "Yes",
        installationType: "adhesive laid install",
        recommendedZone: "Zone 3",
        bestUseCase: "vestibules, entryways, hallways, store ailes"
      },
    keyFeatures: ["Re-engineered to be a Class 1 product", "The warmth and resilience of velour carpeting", "A favorite in pharmacies for comfort"],
      gallery: ["/Assets/images/products/senator-softstep-plus-ctg/softstep_united_529_pharmacy.jpg", "/Assets/images/products/senator-softstep-plus-ctg/softstep_office.jpg", "/Assets/images/products/senator-softstep-plus-ctg/senator-softstep-plus-ctg_gallery_1.jpg", "/Assets/images/products/senator-softstep-plus-ctg/senator-softstep-plus-ctg_gallery_2.jpg", "/Assets/images/products/senator-softstep-plus-ctg/senator-softstep-plus-ctg_gallery_3.jpg"],
      swatches: [
        {name: "Charcoal", image: "/Assets/images/products/senator-softstep-plus-ctg/swatches/CHARCOAL.jpg"},
        {name: "Brown", image: "/Assets/images/products/senator-softstep-plus-ctg/swatches/BROWN.jpg"}
      ],
      isPlaceholder: false,
      description: "In environments where employees spend hours on their feet, flooring plays an important role in daily comfort. Senator SoftStep™ Plus Carpet Tile is designed to help reduce fatigue with a supportive foam backing that cushions each step and eases pressure on feet and legs. The velour-style surface provides a warm, professional appearance while standing up to continuous use in demanding workplaces like pharmacies, service counters, and workstations. Available in multiple tile sizes and engineered to meet Class 1 performance standards, Senator SoftStep™ Plus offers a practical flooring solution built for comfort and durability.",
      features: ["Re-engineered to be a Class 1 product", "The warmth and resilience of velour carpeting", "A favorite in pharmacies for comfort"],
      specifications: {},
      fourUpSwatches: [
        {name: "Charcoal", image: "/Assets/images/products/senator-softstep-plus-ctg/four-up/SenatorSoftStep_4tile_Charcoal.jpg"},
        {name: "Brown", image: "/Assets/images/products/senator-softstep-plus-ctg/four-up/SenatorSoftStep_4tile_Brown.jpg"}
      ]
    },
  {
      id: 88,
      slug: "griffin-tile-ctg",
      name: "Griffin Tile",
      variant: "Carpet Tile Goods",
      type: "Carpet Tile Goods",
      category: "Carpet Tile",
      releasedAt: "2026-10-16",

    categoryId: "carpet-tile",
      productSheetPdf: "/Assets/pdf/griffin-tile-ctg/PS_ISS_GriffinTile.pdf",
      techSpecsPdf: "/Assets/pdf/griffin-tile-ctg/PS_TechSpecs_GriffinTile.pdf",
      saleSheetPdf: "/Assets/pdf/griffin-tile-ctg/PS_ISS_GriffinTile.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 3,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Educational Institutions", "Government", "Specialty Stores"],
      colorTones: ["charcoal", "grey", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/griffin-tile-ctg/griffin-tile-ctg_thumbnail.jpg",
      heroImage: "/Assets/images/products/griffin-tile-ctg/griffin-tile-ctg_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified"}
      ],
      comparisonSpecs: {
        material: "28% Globe Nylon + 72% Polypropylene Scraper Yarn",
        construction: "Nonwoven Twisted Loop Pile",
        backing: "Eco Bitumen",
        thickness: "0.25 inch",
        trafficRating: "Medium",
        slipResistance: "Yes",
        installationType: "Loose lay (checker pattern)",
        recommendedZone: "Zone 3",
        bestUseCase: "Offices, lobbies, retail, waiting areas"
      },
      keyFeatures: [
        "Construction: Nonwoven Twisted Loop Pile Structure",
        "Fiber: 28% Globe Nylon + 72% Polypropylene Scraper Yarn",
        "Backing: Eco Bitumen"
      ],
      gallery: [
        "/Assets/images/products/griffin-tile-ctg/griffin-tile_reception.jpg",
        "/Assets/images/products/griffin-tile-ctg/griffin-tile_grocery.jpg",
        "/Assets/images/products/griffin-tile-ctg/griffin-tile_closeup_night-stone.jpg",
        "/Assets/images/products/griffin-tile-ctg/griffin-tile_closeup_sandy-brown.jpg",
        "/Assets/images/products/griffin-tile-ctg/griffin-tile_closeup_harbor-grey.jpg"
      ],
      swatches: [
        {name: "Night Stone", image: "/Assets/images/products/griffin-tile-ctg/swatches/night-stone.jpg"},
        {name: "Sandy Brown", image: "/Assets/images/products/griffin-tile-ctg/swatches/sandy-brown.jpg"},
        {name: "Harbor Grey", image: "/Assets/images/products/griffin-tile-ctg/swatches/harbor-grey.jpg"}
      ],
      fourUpSwatches: [
        {name: "Night Stone", image: "/Assets/images/products/griffin-tile-ctg/four-up/griffin-tile_4tile_night-stone.jpg"},
        {name: "Sandy Brown", image: "/Assets/images/products/griffin-tile-ctg/four-up/griffin-tile_4tile_sandy-brown.jpg"},
        {name: "Harbor Grey", image: "/Assets/images/products/griffin-tile-ctg/four-up/griffin-tile_4tile_harbor-grey.jpg"}
      ],
      isPlaceholder: false,
      description: [
        "Griffin Tile brings clean, modern character to active office environments. Its designer loop-pile surface and low-profile construction create a polished foundation that supports effortless movement of furniture, office chairs, and rolling carts.",
        "Crafted for constant foot traffic, Griffin Tile balances refined styling with dependable everyday durability. It is a practical, lasting flooring solution for offices, corridors, reception areas, and other professional spaces that rarely slow down."
      ],
      features: [
        "Construction: Nonwoven Twisted Loop Pile Structure",
        "Fiber: 28% Globe Nylon + 72% Polypropylene Scraper Yarn",
        "Backing: Eco Bitumen"
      ],
      specifications: {
        construction: "24 oz. Nonwoven Twisted Loop Scraper",
        pileWeight: "24 oz/yd²",
        tileSize: "19.69\" x 19.69\""
      }
    },
];
